export const oemSites = {
  acura: 'https://www.acura.com',
  alfaromeo: 'https://www.alfaromeousa.com',
  audi: 'https://www.audiusa.com',
  bmw: 'https://www.bmwusa.com',
  buick: 'https://www.buick.com',
  cadillac: 'https://www.cadillac.com',
  chevrolet: 'https://www.chevrolet.com',
  chrysler: 'https://www.mopar.com',
  fiat: 'https://www.fiatusa.com',
  ford: 'https://www.ford.com',
  genesis: 'https://owners.genesis.com',
  gmc: 'https://www.gmc.com',
  honda: 'https://mygarage.honda.com',
  hyundai: 'https://www.hyundaiusa.com',
  infiniti: 'https://www.infinitiusa.com',
  jaguar: 'https://www.jaguarusa.com',
  jeep: 'https://www.jeep.com',
  kia: 'https://owners.kia.com',
  landrover: 'https://www.landroverusa.com',
  lexus: 'https://www.lexus.com',
  lincoln: 'https://www.lincoln.com',
  lucid: 'https://lucidmotors.com',
  maserati: 'https://www.maserati.com/us/en',
  mazda: 'https://www.mazdausa.com',
  mercedes: 'https://www.mbusa.com/en/home',
  mini: 'https://www.miniusa.com',
  mitsubishi: 'https://www.mitsubishicars.com',
  nissan: 'https://www.nissanusa.com',
  polestar: 'https://www.polestar.com/us/',
  porsche: 'https://www.porsche.com',
  ram: 'https://www.ramtrucks.com',
  rivian: 'https://rivian.com',
  scion: 'https://www.toyota.ca/toyota/en/scion-owners',
  smart: 'https://uk.smart.com/en/',
  subaru: 'https://subarudrive.com',
  tesla: 'https://www.tesla.com',
  toyota: 'https://www.toyota.com',
  volkswagen: 'https://www.vw.com',
  volvo: 'https://www.volvocars.com',
};

export default oemSites;
